import React, { Fragment, Component } from 'react';
import styled from 'styled-components';
import { Box, Button, Card, Flex, Heading, Text } from 'rebass';
import { compose, withApollo, Mutation } from 'react-apollo';
import SpinLoader from '../../components/SpinLoader';
import Dropzone from 'react-dropzone';
import addFile from '../../static/addFile.png';
import { withToastManager } from 'react-toast-notifications';
import { ADMIN_BATCH_TOGGLE_FORCE_BYPASS_BRIDGE } from '../../graphql';

const Container = styled(Box)`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding-top: 48px;
`;
const StyledText = styled(Text)`
  line-height: 1.6;
  border-bottom: 1px solid;
  color: white;
  text-align: center;

  &:hover {
    cursor: pointer;
    font-weight: 600;
  }
`;

const UploadedRecord = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: 1fr;
  align-items: center;
  grid-template-areas: 'icon content button';
`;

const Inner = styled.section`
  &:focus {
    outline: none;
  }

  &:hover {
    cursor: pointer;
  }
`;
class BatchToggleForceBypassBridge extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentFile: null,
      res: null,
    };
  }

  fileAccepted = (f, callback) => {
    const element = f;

    const reader = new FileReader();
    reader.onload = (event) => {
      let fls = f;
      console.log('ee, ', event.target.result);
      fls = {
        fileName: element.name,
        mimeType: element.type,
        data: event.target.result,
      };

      callback(fls);
    };
    reader.onerror = (e) => {
      console.log('Err', e);
    };
    reader.readAsDataURL(element);
  };

  handleRejected = ([file]) => {
    const { toastManager } = this.props;
    toastManager.add('Only PDF files are supported', {
      appearance: 'error',
    });
  };

  handleError = (error) => {
    const { toastManager, deleteFile } = this.props;
    console.log(error);
    toastManager.add('Unable to upload file, please try again', {
      appearance: 'error',
    });

    this.setState({
      currentFile: {},
    });
  };
  handleDownloadTemplate = () => {
    const fileContent = 'athenaId,forceBypassBridge\n';
    const blob = new Blob([fileContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'forceBypassBridgeTemplate.csv'; // File name
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url); // Clean up
  };
  render() {
    const { currentFile, res } = this.state;
    return (
      <Container>
        <Flex m={[3, 5]} flex={1} flexDirection="column">
          <Heading mb={4} mt={[3, 0]} ml={[1, 0]} fontSize={[4, 5]}>
            Batch Toggle Force Bypass Bridge
          </Heading>
          <Text>File Headers: "athenaId" "forceBypassBridge"</Text>
          <Text>"forceBypassBridge" value must be either "true" or "false" (without quotes)</Text>
          <Text mt={4} mb={3}>
            "forceBypassBridge" value at true means patient will automatically be redirected to legacy scheduling flow and won't be able to use Bridge for insurance
          </Text>
          <Button variant={'outline'} style={{width: 'fit-content'}} onClick={this.handleDownloadTemplate} mb={4} justifySelf={'center'} alignSelf={'center'}>
            Download CSV Template
          </Button>
          <Card mb={4} p={[3, 4]}>
            <Mutation
              mutation={ADMIN_BATCH_TOGGLE_FORCE_BYPASS_BRIDGE}
              onError={this.handleError}
              onCompleted={(res) => {
                console.log(res);

                this.setState({
                  currentFile: {},
                  res: res.batchToggleForceBypassBridge,
                });
              }}
            >
              {(mutate, { loading }) => (
                <Dropzone
                  id="dropzone"
                  multiple={false}
                  accept="text/csv"
                  onDropRejected={this.handleRejected}
                  onDropAccepted={([file]) => {
                    this.fileAccepted(file, async (ff) => {
                      await mutate({ variables: { file: ff.data } });
                    });
                    this.setState({
                      currentFile: file,
                    });
                  }}
                  maxSize={10000000}
                  style={{ width: '100%', height: '100%' }}
                >
                  {({ getRootProps, getInputProps, isDragActive }) => (
                    <Inner>
                      <div {...getRootProps()} className={`dropzone ${isDragActive ? 'dropzone--isActive' : ''}`}>
                        <input type="file" {...getInputProps()} />
                        <img src={addFile} height={36} alt="" />
                        {loading ? (
                          <Fragment>
                            <div
                              style={{
                                textAlign: 'center',
                                overflowX: 'hidden',
                                overflowY: 'hidden',
                              }}
                            >
                              <Text
                                fontSize={3}
                                fontWeight={500}
                                mr={2}
                                style={{
                                  marginTop: '36px',
                                  marginBottom: '18px',
                                }}
                              >
                                Uploading your file
                              </Text>
                              {currentFile &&
                                currentFile.name && (
                                  <Text
                                    fontSize={3}
                                    fontWeight={300}
                                    mr={2}
                                    style={{
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      marginBottom: '36px',
                                    }}
                                  >
                                    {currentFile.name}
                                  </Text>
                                )}
                              <SpinLoader width={32} height={32} style={{ margin: '0 auto' }} />
                            </div>
                          </Fragment>
                        ) : (
                          <Fragment>
                            <Text fontSize={[2]} style={{ marginTop: '24px' }}>
                              Drop your file here. Process will automatically start on drop
                            </Text>
                          </Fragment>
                        )}
                      </div>
                    </Inner>
                  )}
                </Dropzone>
              )}
            </Mutation>
          </Card>
          {res ? (
            <>
              <div>success: {res.ok.toString()}</div>
              {res.customError && (
                <div>
                  error: {res.customError.errorMessage}
                  <br /> {res.customError.userMessage}
                </div>
              )}
              {res.result && (
                <div>
                  {res.result.map((x) => {
                    return (
                      <>
                        <div>{x.record}</div>
                        <div>result: {x.result}</div>
                        <div style={{ marginBottom: '18px' }}>updatedCount: {x.reason}</div>
                      </>
                    );
                  })}
                </div>
              )}
            </>
          ) : null}
        </Flex>
      </Container>
    );
  }
}
export default compose(
  withApollo,
  withToastManager
)(BatchToggleForceBypassBridge);
